import React, { useEffect, useState, useRef } from "react";
import {
    TableHead,
    TableBody,
    Table,
    TableContainer,
    TableCell,
    TableRow,
    Box,
    Pagination,
    Button,
    FormControl,
    Autocomplete,
    TextField,
    Typography,
    Grid,
    Card,
    CardContent,
    Paper,
    TablePagination,
    IconButton,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";
import { commonRunQuery } from "../../util/API/loans";
import { PieChart, Pie, Cell, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend } from "recharts";
import "./LoanUserDueReportTab.scss";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import pdfImage from "../../images/pdf-image.svg"
import { CSVLink } from "react-csv";
import moment from "moment";
import CSVImage from "../../images/csv-file.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";

const LoanUserDueReportTab = ({ selectedUser }) => {
    const now = moment();

    const [loansDueData, setLoansDueData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [dateFilter, setDateFilter] = useState("month"); 
    const [dateRange, setDateRange] = useState({ startDate: now.startOf("month").format("YYYY-MM-DD HH:mm:ss"), endDate: now.endOf("month").format("YYYY-MM-DD HH:mm:ss") });
    const [paymentStatusFilter, setPaymentStatusFilter] = useState('');

    // const card1Ref = useRef(null);
    // const card2Ref = useRef(null);

    const paymentOptions = ["Not Fully Paid", "Fully Paid", "Cancelled"];
    const COLORS = ["#0088FE", "#00C49F", "#FF003F"];

    // useEffect(() => {
    //     if (card1Ref.current && card2Ref.current) {
    //       const card1Height = card1Ref.current.clientHeight;
    //       const card2Height = card2Ref.current.clientHeight;
    
    //       // Find the maximum height
    //       const maxCardHeight = Math.max(card1Height, card2Height);
    //         console.log("maxCardHeight-----------",maxCardHeight);
    //       // Set the height of both cards to be the same (the max height)
    //       setMaxHeight(maxCardHeight);
    //     }
    // }, [card1Ref.current?.clientHeight, card2Ref.current?.clientHeight]);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        backgroundColor: "rgba(0,0,0, .1)",
        color: theme.palette.common.black,
        fontWeight: "bold",
        textAlign:"center",
        },
        [`&.${tableCellClasses.body}`]: {
        fontSize: 25,
        fontWeight: "600",
        },
    }));

    const titleRow = [
        `Due Loans Report`,
      ];

    const csvData = [
        // Add the title row as the first row
        titleRow,
        // Add an empty row to separate the title from the header
        [],
        //These will be header columns
        [
            'Status',
            'Disbursement Amount',
            'Disbursement Type',
            'Issued Amount',
            'Issued Date',
            'Due Date',
            'Outstanding Principle',
            'Outstanding Late Fees',
            'Total Amount',
            'Total Amount Applied'
        ],
        // Add the data rows
        ...loansDueData.map((row) => [
            row?.loanissued?.fullypaidind == "0" ? "Not Fully Paid" : row?.loanissued?.fullypaidind == "1" ? "Fully Paid" : "Cancelled",
            row?.loanissued?.disbursementamount,
            row?.loanissued?.disbursementtype,
            row?.loanissued?.issuedamount,
            row?.loanissued?.issueddate,
            row?.loanissued?.loanduedate,
            row?.loanissued?.outstandingprinciple,
            row?.loanissued?.outstandinglatefees,
            row?.loanissued?.totalamount,
            row?.loanissued?.totalamountapplied
        ]),
    ];

    const runPDF = () => {
        const doc = new jsPDF();
        const title = "Loan Status Report";
    
        // Title
        doc.setFontSize(18);
        doc.text(title, 14, 22);
    
        // Optional: Filter Info
        const filters = `Status: ${paymentStatusFilter || "All"} | Term Type: ${dateFilter}`;
        doc.setFontSize(11);
        doc.text(filters, 14, 30);
    
        // Table Header
        const headers = [
            [
                'Status',
                'Disbursement Amount',
                'Disbursement Type',
                'Issued Amount',
                'Issued Date',
                'Due Date',
                'Outstanding Principle',
                'Outstanding Late Fees',
                'Total Amount',
                'Total Amount Applied'
            ]
        ];
    
        // Table Body
        const data = filteredData.map((row) => [
            row?.loanissued?.fullypaidind == "0" ? "Not Fully Paid" : row?.loanissued?.fullypaidind == "1" ? "Fully Paid" : "Cancelled",
            row?.loanissued?.disbursementamount,
            row?.loanissued?.disbursementtype,
            row?.loanissued?.issuedamount,
            row?.loanissued?.issueddate,
            row?.loanissued?.loanduedate,
            row?.loanissued?.outstandingprinciple,
            row?.loanissued?.outstandinglatefees,
            row?.loanissued?.totalamount,
            row?.loanissued?.totalamountapplied
        ]);
    
        // Generate PDF Table
        autoTable(doc, {
            head: headers,
            body: data,
            startY: 38,
            styles: {
                fontSize: 8,
                cellPadding: 2,
            },
            headStyles: {
                fillColor: [22, 160, 133],
            }
        });
    
        // Save PDF
        doc.save("LoanDueReport.pdf");
    };

    useEffect(()=> {
        getUserDueLoans();
    },[]);

    const getUserDueLoans = async() => {
        try {
            const response = await commonRunQuery(245, `${selectedUser}/${dateRange.startDate}/${dateRange.endDate}`);
            if(response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0") {
                const loansDueDataArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                console.log("loansDueDataArray================",loansDueDataArray);
                setLoansDueData(loansDueDataArray);
            } else {
                setLoansDueData([]);
            }
        } catch (error) {
            console.log("getUserLoanRequests_error================",error);
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getDateRange = (filterType) => {
        const now = moment(); // Current date & time
        let startDate, endDate;
    
        switch (filterType) {
            case "today":
                startDate = now.startOf("day").format("YYYY-MM-DD HH:mm:ss");
                endDate = now.endOf("day").format("YYYY-MM-DD HH:mm:ss");
                break;
    
            case "week":
                startDate = now.startOf("week").format("YYYY-MM-DD HH:mm:ss");  
                endDate = now.endOf("week").format("YYYY-MM-DD HH:mm:ss");
                break;
    
            case "month":
                startDate = now.startOf("month").format("YYYY-MM-DD HH:mm:ss");
                endDate = now.endOf("month").format("YYYY-MM-DD HH:mm:ss");
                break;
    
            case "year":
                startDate = now.startOf("year").format("YYYY-MM-DD HH:mm:ss");
                endDate = now.endOf("year").format("YYYY-MM-DD HH:mm:ss");
                break;
    
            default:
                return null;
        }
    
        return { startDate, endDate };
    };

    const handleDateFilterChange = async(e) => {
        try {
            setDateFilter(e.target.value);
            setPage(0);

            const range = await getDateRange(e.target.value);

            if (range) {
                setDateRange(range);
                const response = await commonRunQuery(245, `${selectedUser}/${range.startDate}/${range.endDate}`);
                if(response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0") {
                    const loansDueDataArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                    console.log("loansDueDataArray================",loansDueDataArray);
                    setLoansDueData(loansDueDataArray);
                } else {
                    setLoansDueData([]);
                }
            }
        } catch (error) {
            console.log("handleDateFilterChange_error================",error);
        }
    }

    const filteredData = loansDueData.filter((row) => {
        const paymentMatch = paymentStatusFilter
            ? (row?.loanissued?.fullypaidind === "1" && paymentStatusFilter === "Fully Paid") ||
              (row?.loanissued?.fullypaidind === "0" && paymentStatusFilter === "Not Fully Paid") ||
              (row?.loanissued?.fullypaidind === "2" && paymentStatusFilter === "Cancelled")
            : true;
    
        return paymentMatch;
    });

    const paymentStatusData = [
        { name: "Not Fully Paid", value: loansDueData.filter(row => row?.loanissued?.fullypaidind === "0").length, color: "#FF6384" },
        { name: "Fully Paid", value: loansDueData.filter(row => row?.loanissued?.fullypaidind === "1").length, color: "#36A2EB" },
        { name: "Cancelled", value: loansDueData.filter(row => row?.loanissued?.fullypaidind === "2").length, color: "#FFCE56" }
    ];

    return (
        <Box className="user-loan-due-container">
            <Typography variant="h5" sx={{ mb: 2 }}>Due Loans Report</Typography>
            <Box sx={{ mt: 4 }}>
                {/* Pie Chart COntainer */}
                {loansDueData && loansDueData?.length > 0 && <Box className="mb-4">
                    <Grid container spacing={3} className="m-0" >
                        <Card className="grid-cards">
                            <CardContent 
                                sx={{
                                    transition: "transform 0.3s ease-in-out, filter 0.3s ease-in-out",
                                    "&:hover": {
                                        transform: "scale(1.02)", 
                                        filter: "drop-shadow(5px 5px 10px rgba(0,0,0,0.2))", // Adds a shadow
                                    },
                                }}
                            >
                                <PieChart width={300} height={300}>
                                    <Pie 
                                        data={paymentStatusData} 
                                        cx="50%" 
                                        cy="40%" 
                                        outerRadius={80} 
                                        fill="#8884d8" 
                                        dataKey="value"
                                        label
                                    >
                                        {paymentStatusData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index]} />
                                        ))}
                                    </Pie>
                                    <Tooltip />
                                    <Legend verticalAlign="bottom" align="center" iconType="circle" />
                                </PieChart>
                            </CardContent>
                        </Card>
                    </Grid>
                </Box>}

                <Box className="d-flex justify-content-end">
                    {/* <Typography sx={{ display:"flex", alignItems:"flex-end" }} variant="h6">Loan Requests</Typography> */}
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        {/* <Box>
                            <CSVLink
                                data={csvData}
                                filename={`TestName.csv`}
                            >
                                <img src={CSVImage} className="excel-icon" />
                            </CSVLink>{" "}
                        </Box> */}

                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            <Box>
                                <CSVLink
                                    data={csvData}
                                    filename={`LoanDueReport.csv`}
                                >
                                    <IconButton
                                        sx={{
                                            width: 40,
                                            height: 40,
                                            color: "#6c757d",
                                            "&:hover": {
                                            backgroundColor: "rgba(108, 117, 125, 0.1)",
                                            },
                                        }}
                                    >
                                        <img src={CSVImage} style={{ width:"48px" }} loading="lazy" />
                                    </IconButton>
                                </CSVLink>{" "}
                            </Box>

                            <Box>
                                <IconButton
                                    onClick={runPDF}
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        color: "#6c757d",
                                        backgroundColor: "transparent",
                                        "&:hover": {
                                            backgroundColor: "rgba(108, 117, 125, 0.1)",
                                        },
                                    }}
                                >
                                    <img src={pdfImage} alt="PDF" loading="lazy" />
                                </IconButton>
                            </Box>
                        </Box>

                        {/* Payment Status Filter */}
                        <FormControl size="small" sx={{ minWidth: 160 }}>
                            <InputLabel>Payment Status</InputLabel>
                            <Select
                                value={paymentStatusFilter}
                                label="Payment Status"
                                onChange={(e) => {
                                    setPaymentStatusFilter(e.target.value);
                                    setPage(0);
                                }}
                            >
                                <MenuItem value="">All</MenuItem>
                                {paymentOptions.map((paymentStatus, index) => (
                                    <MenuItem key={index} value={paymentStatus}>{paymentStatus}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* Date Filter */}
                        <FormControl size="small" sx={{ minWidth: 120 }}>
                            <InputLabel>Date Filter</InputLabel>
                            <Select
                                value={dateFilter}
                                label="Term Type"
                                // onChange={(e) => {
                                //     setDateFilter(e.target.value);
                                //     setPage(0);
                                // }}
                                onChange={handleDateFilterChange}
                            >
                                {/* <MenuItem value="">All Time</MenuItem> */}
                                <MenuItem value="today">Today</MenuItem>
                                <MenuItem value="week">This Week</MenuItem>
                                <MenuItem value="month">This Month</MenuItem>
                                <MenuItem value="year">This Year</MenuItem>
                                {/* <MenuItem value="custom">Custom</MenuItem> */}
                            </Select>
                        </FormControl>
                    </Box>
                </Box>

                {/* Loan Due Reports Table */}
                <TableContainer className="bordered-table mt-2">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Status</StyledTableCell>
                                <StyledTableCell>Disbursement Amount</StyledTableCell>
                                <StyledTableCell>Disbursement Type</StyledTableCell>
                                <StyledTableCell>Issued Amount</StyledTableCell>
                                <StyledTableCell>Issued Date</StyledTableCell>
                                <StyledTableCell>Due Date</StyledTableCell>
                                <StyledTableCell>Outstanding Principle</StyledTableCell>
                                <StyledTableCell>Outstanding Late Fees</StyledTableCell>
                                <StyledTableCell>Total Amount</StyledTableCell>
                                <StyledTableCell>Total Amount Applied</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData && filteredData.length > 0 ? filteredData
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell align="center">{row?.loanissued?.fullypaidind == "0" ? "Not Fully Paid" : row?.loanissued?.fullypaidind == "1" ? "Fully Paid" : "Cancelled" }</TableCell>
                                        <TableCell align="center">{Number(row?.loanissued?.disbursementamount).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                        <TableCell align="center">{row?.loanissued?.disbursementtype}</TableCell>
                                        <TableCell align="center">{Number(row?.loanissued?.issuedamount).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                        <TableCell align="center">{row?.loanissued?.issueddate}</TableCell>
                                        <TableCell align="center">{row?.loanissued?.loanduedate}</TableCell>
                                        <TableCell align="center">{Number(row?.loanissued?.outstandingprinciple).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                        <TableCell align="center">{Number(row?.loanissued?.outstandinglatefees).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                        <TableCell align="center">{Number(row?.loanissued?.totalamount).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                        <TableCell align="center">{Number(row?.loanissued?.totalamountapplied).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                    </TableRow>
                                ))
                                :
                                <TableRow>
                                    <TableCell align="center" colSpan={9}>
                                        <Typography variant="body1" color="textSecondary">
                                            No data available
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Box>
        </Box>
    )
}

export default LoanUserDueReportTab;